
import $ from 'jquery';
import tips from './tips';
import api from './api';
import { state } from './main'

const REWARD_POPUP_MAP = {
  1: {
    type: 'oneReward',
    imgIndex: '3',
    rewardText: '高級經驗書x20'
  },
  2: {
    type: 'oneReward',
    imgIndex: '8',
    rewardText: '鋸木令x10'
  },
  3: {
    type: 'oneReward',
    imgIndex: '11',
    rewardText: '煉鐵令x10'
  },
  4: {
    type: 'oneReward',
    imgIndex: '15',
    rewardText: '屯田令x10'
  },
  5: {
    type: 'oneReward',
    imgIndex: '10',
    rewardText: '酒帖x10'
  },
  6: {
    type: 'oneReward',
    imgIndex: '16',
    rewardText: '鑄幣令x10'
  },
  7: {
    type: 'oneReward',
    imgIndex: '5',
    rewardText: '急速行軍x20'
  },
  8: {
    type: 'oneReward',
    imgIndex: '7',
    rewardText: '登庸令x10'
  },
  9: {
    type: 'oneReward',
    imgIndex: '12',
    rewardText: '輜重箱x20'
  },
  10: {
    type: 'oneReward',
    imgIndex: '7',
    rewardText: '登庸令x20'
  },
  11: {
    type: 'oneReward',
    imgIndex: '4',
    rewardText: '黄金沙漏x30'
  },
  12: {
    type: 'quan',
    imgIndex: '1000',
    rewardText: '1000'
  },
  13: {
    type: 'oneReward',
    imgIndex: '12',
    rewardText: '輜重箱x5'
  },
  14: {
    type: 'oneReward',
    imgIndex: '14',
    rewardText: '戰鼓x20'
  },
  15: {
    type: 'oneReward',
    imgIndex: '13',
    rewardText: '元寶x300'
  },
  16: {
    type: 'oneReward',
    imgIndex: '13',
    rewardText: '元寶x1000'
  },
  17: {
    type: 'quan',
    imgIndex: '2000',
    rewardText: '2000'
  },
  18: {
    type: 'oneReward',
    imgIndex: '5',
    rewardText: '急速行軍x30'
  },
  19: {
    type: 'oneReward',
    imgIndex: '7',
    rewardText: '登庸令x50'
  },
  20: {
    type: 'quan',
    imgIndex: '7000',
    rewardText: '7000'
  },
  21: {
    type: 'oneReward',
    imgIndex: '12',
    rewardText: '輜重箱x50'
  },
  22: {
    type: 'multiReward',
    imgIndex: [12, 4, 5],
    rewardText: ['輜重箱x100', '黃金沙漏x50', '急速行軍x50']
  },
  23: {
    type: 'quan',
    imgIndex: '30000',
    rewardText: '30000'
  },

  24: {
    type: 'multiReward',
    imgIndex: [3, 9, 12],
    rewardText: ['高級經驗書x10', '快速行軍x10', '輜重箱x10']
  },
  25: {
    type: 'multiReward',
    imgIndex: [7, 14, 17],
    rewardText: ['登庸令*5', '戰鼓*10', '白銀沙漏*10']
  },
  26: {
    type: 'multiReward',
    imgIndex: [4, 5, 15],
    rewardText: ['黃金沙漏x10', '急速行軍x10', '屯田令*5']
  },
  27: {
    type: 'multiReward',
    imgIndex: [8, 16, 11],
    rewardText: ['鋸木令x10', '鑄幣令x10', '煉鐵令*10']
  },
  28: {
    type: 'multiReward',
    imgIndex: [7, 14, 12],
    rewardText: ['登庸令*15', '戰鼓x20', '輜重箱x20']
  },
  29: {
    type: 'multiReward',
    imgIndex: [13, 12, 5],
    rewardText: ['元寶x1000', '輜重箱x30', '急速行軍x50']
  },
  30: {
    type: 'multiReward',
    imgIndex: [7, 13, 12],
    rewardText: ['登庸令*50', '元寶x3000', '輜重箱x50']
  },
}

export const initRecord = async () => {
  const res = await api.getRecord()
  if (res && +res.code === 1) {
    if (res.data && res.data.gifts && res.data.gifts.length) {
      let html = ''
      res.data.gifts.forEach(item => {
        html += `<tr>
        <th>${item.createTime}</th>
        <th>${item.type}</th>
        <th>${item.name}</th>
        <th>${item.sendType == 'coupon' ? '<a class="look" href="//mstore.gm99.com/points/#/coupon" target="_blank">[查看卡券]</a>' : `已領取到 ${item.serverName}-${item.roleName}`} </th>
      </tr>`
      })
      $('.j-table-wrap').removeClass('border')
      $('.j-record-body').html(html)
    } else {
      $('.j-table-wrap').addClass('border')
      $('.j-no-record-tips-wrap').show()
    }
    $('.j-popup-record').fadeIn()
  } else {
    showTips(tips.get(res.code));
  }
}

export const showTips = (tip) => {
  const TIP_MAP = {
    '您尚未完成任意渠道儲值，無法領取抵扣券': 'jump',
    '活動已結束，謝謝參與。<br/>現在儲值不會獲得抽獎券獎勵，是否要繼續？': 'jump',
    '請先登錄帳號': 'login'
  }
  TIP_MAP[tip] ? $('.j-popup-tip-btn').addClass(TIP_MAP[tip]) : $('.j-popup-tip-btn').removeClass(TIP_MAP[tip])
  $('.j-popup-text').html(tip);
  $('.j-popup').fadeOut()
  $('.j-popup-tip').fadeIn();
}

export const handleZhanliPopup = async () => {
  const res = await api.getZhanli()
  if (res && +res.code === 1 && res.data && res.data.ceValue) {
    $('.j-zhanli').html(res.data.ceValue)
    if (res.data.ceValue == '大將軍') {
      $('.j-zhanli-tip').show()
    }
    state.ce ? $('.j-zhanli-lingqu').addClass('get') : ''
    $('.j-popup-zhanli').fadeIn()
  } else {
    showTips(tips.get(res.code));
  }
}

export const handleRewardPopup = (id) => {
  switch (REWARD_POPUP_MAP[id].type) {
    case 'oneReward': {
      $('.j-gift-item-img').removeClass(getLotteryPopupImgClass()).addClass(`gift-item-img-${REWARD_POPUP_MAP[id].imgIndex}`)
      $('.j-gift-item-text').html(REWARD_POPUP_MAP[id].rewardText)
      $('.j-popup-lottery').fadeIn()
      break;
    }
    case 'multiReward': {
      if (id == 22) {
        $('.j-popup-multi-title').html('恭喜獲得')
      } else {
        $('.j-popup-multi-title').html('簽到成功！')
      }
      $('.j-popup-multi-img').removeClass(getLotteryPopupImgClass())
      for (let i = 0; i < 3; i++) {
        $('.j-popup-multi-img').eq(i).addClass(`gift-item-img-${REWARD_POPUP_MAP[id].imgIndex[i]}`)
        $('.j-popup-multi-text').eq(i).html(REWARD_POPUP_MAP[id].rewardText[i])
      }
      $('.j-popup-multi').fadeIn()
      break;
    }
    case 'quan': {
      handleQuanPopup(REWARD_POPUP_MAP[id].rewardText)
      break;
    }
  }
}

export const handleQuanPopup = (num) => {
  $('.j-quan').removeClass(`quan_50 quan_300 quan_1000 quan_2000 quan_7000 quan_30000`).addClass(`quan_${num}`)
  $('.j-popup-quan').fadeIn()
}

const getLotteryPopupImgClass = () => {
  let classStr = ''
  for (let i = 1; i <= 16; i++) {
    classStr += `gift-item-img-${i} `
  }
  return classStr
}

